import React from 'react';
import { Route, Switch } from 'dva/router';
import { Nav, Ad, NavTop } from '../../component';
import routes from '../..//route';
import Page404 from '../error/404';
import Header from './header';
import Tail from './tail';
import { connect } from 'dva';
import styles from './index.css';

var flag = false;   //阻止无限更新state状态

class App extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			header_status: false,
			iframeSrc: ''
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll = (e) => {
		if (document.documentElement.scrollTop > 350) {
			if (!flag) {
				this.setState({
					header_status: true
				})
				flag = !flag;
			}
		} else {
			if (flag) {
				this.setState({
					header_status: false
				})
				flag = !flag
			}
		}
	}

	iframeSrcFn = (src) => {
		this.setState({
			iframeSrc: src
		})
	}

	render() {
		return (
			<div>
				<div >
					<div className={styles.scroll_top}>
						{this.state.header_status && <NavTop route={routes.filter(item => item.nav_name)} top_anim={this.state.header_status} />}
						<Nav route={routes.filter(item => item.nav_name)} />
					</div>
					<div className={styles.top_height}>
						<Switch >
							{routes.filter(item => item.path).map(item =>
								<Route exact key={item.path} path={item.path} component={item.component} />
							)}
							<Route component={Page404} />
						</Switch>
					</div>
					<div style={{ height: '30px' }} />
					<Tail />
				</div>
			</div>
		);
	}

}

const state_props = state => {
	return {
		ad: state.ad.data,
	}
}

export default connect(state_props)(App);



// WEBPACK FOOTER //
// ./src/layout/app/index.js